import { render, staticRenderFns } from "./SubmitExperienceButtonWrapper.vue?vue&type=template&id=876df50e&"
import script from "./SubmitExperienceButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./SubmitExperienceButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports